// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import styles from './TopBar.styles';
import Menu from 'app/components/Menu';
import DrawerMenu from 'app/components/DrawerMenu';
import SearchBox from 'app/components/SearchBox';
import TopBarSocialIcons from 'app/components/TopBarSocialIcons';
import TopBarLogo from 'app/components/TopBarLogo';
import SecondaryMenu from 'app/components/SecondaryMenu';
import SideNewsButton from 'app/components/SideNewsButton';

class TopBar extends React.Component<Props> {
    render() {
      const {classes} = this.props;    
      return (
        <React.Fragment>
          <AppBar color="default" elevation={0} className={classes.root}>

            <Toolbar className={classes.toolbar}>
              <DrawerMenu />
              <TopBarLogo />
              <div className={classes.rowsWrapper}>
                <div className={classes.rowTop}>
                  <SecondaryMenu />
                  <TopBarSocialIcons className={classes.socialIcons} />
                </div>

                <div className={classes.rowBottom}>
                  <Menu />
                  <SearchBox className={classes.searchBox} />
                </div>
              </div>

              <SideNewsButton />
            </Toolbar>

          </AppBar>

          <div className={classes.spacer}> </div>
        </React.Fragment>
      );
    }
}


const Component = withStyles(styles)(TopBar);
export {Component as TopBar};